// ink-component
import React from 'react';
import styled from 'styled-components';

import FooterActions, { FooterActionsProps } from '../../FooterActions/FooterActions';

import { modalTokens } from '../../../tokens/components/Modal/tokens';

import getGlobalProps from '../../../helpers/constants/global-props';
import { MOBILE_WIDTH } from '../../../helpers/constants/responsive-breakpoints';

export interface ModalFooterProps extends FooterActionsProps {}

const ModalFooterWrapper = styled.div`
  margin-top: ${modalTokens.FooterContainerSpacingTopBaseDefault};

  @media (max-width: ${MOBILE_WIDTH}px) {
    margin-top: 0;
    padding-top: ${modalTokens.ContainerSpacingTopBaseDefaultMobile};
    border-top: 1px solid ${modalTokens.ContainerBorderColorBaseDefault};
  }
`;

const globalProps = getGlobalProps({});

/**
 * @purpose Arranges Modal action buttons in a defined set of configurations
 * @group Modal
 */
const ModalFooter = ({ className, style, ...otherProps }: ModalFooterProps) => {
  return (
    <ModalFooterWrapper {...globalProps}>
      <FooterActions {...otherProps} />
    </ModalFooterWrapper>
  );
};

ModalFooter.defaultProps = {
  isLoading: false,
};

ModalFooter.displayName = 'Modal.Footer';

export default ModalFooter;
